module.exports = __webpack_public_path__ + "static/media/Slack_Mark_Web.5c46664e.png";